import React from 'react';

const Toggle = ({ 
  checked = false, 
  onChange, 
  disabled = false, 
  label, 
  description,
  size = 'default',
  variant = 'default'
}) => {
  const sizeClasses = {
    small: 'w-8 h-5',
    default: 'w-11 h-6',
    large: 'w-14 h-7'
  };

  const dotSizeClasses = {
    small: 'w-4 h-4',
    default: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  const translateClasses = {
    small: checked ? 'translate-x-3' : 'translate-x-0',
    default: checked ? 'translate-x-5' : 'translate-x-0',
    large: checked ? 'translate-x-7' : 'translate-x-0'
  };

  const variantClasses = {
    default: checked ? 'bg-green-600' : 'bg-gray-300',
    primary: checked ? 'bg-indigo-600' : 'bg-gray-300',
    success: checked ? 'bg-green-600' : 'bg-gray-300',
    warning: checked ? 'bg-yellow-500' : 'bg-gray-300'
  };

  return (
    <div className="flex items-center">
      <div className="flex items-center">
        <button
          type="button"
          className={`
            ${sizeClasses[size]}
            ${variantClasses[variant]}
            relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent 
            transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 
            focus:ring-indigo-600 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50
          `}
          disabled={disabled}
          onClick={() => !disabled && onChange(!checked)}
          role="switch"
          aria-checked={checked}
          aria-labelledby={label ? `toggle-${label}` : undefined}
        >
          <span
            className={`
              ${dotSizeClasses[size]}
              ${translateClasses[size]}
              pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 
              transition duration-200 ease-in-out
            `}
          />
        </button>
        
        {label && (
          <div className="ml-3">
            <label 
              id={`toggle-${label}`}
              className="text-sm font-medium text-gray-900 cursor-pointer"
              onClick={() => !disabled && onChange(!checked)}
            >
              {label}
            </label>
            {description && (
              <p className="text-sm text-gray-500">{description}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Toggle;